var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.6657C11.9116 16.6657 11.8268 16.6306 11.7643 16.5681C11.7017 16.5055 11.6666 16.4208 11.6666 16.3324C11.6666 16.244 11.7017 16.1592 11.7643 16.0967C11.8268 16.0341 11.9116 15.999 12 15.999",
    fill: "#C56A02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.6657C11.9116 16.6657 11.8268 16.6306 11.7643 16.5681C11.7017 16.5055 11.6666 16.4208 11.6666 16.3324C11.6666 16.244 11.7017 16.1592 11.7643 16.0967C11.8268 16.0341 11.9116 15.999 12 15.999",
    stroke: "#C56A02",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.6657C12.0884 16.6657 12.1732 16.6306 12.2357 16.5681C12.2982 16.5055 12.3333 16.4208 12.3333 16.3324C12.3333 16.244 12.2982 16.1592 12.2357 16.0967C12.1732 16.0341 12.0884 15.999 12 15.999",
    stroke: "#C56A02",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.3327V6.66602",
    stroke: "#C56A02",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.47106 13.138C2.16943 12.836 2 12.4266 2 11.9998C2 11.573 2.16943 11.1636 2.47106 10.8616L10.8622 2.47135C11.0116 2.32192 11.189 2.20338 11.3842 2.1225C11.5794 2.04163 11.7887 2 12 2C12.2113 2 12.4206 2.04163 12.6158 2.1225C12.811 2.20338 12.9884 2.32192 13.1378 2.47135L21.5289 10.8616C21.8306 11.1636 22 11.573 22 11.9998C22 12.4266 21.8306 12.836 21.5289 13.138L13.1378 21.5282C12.9884 21.6777 12.811 21.7962 12.6158 21.8771C12.4206 21.958 12.2113 21.9996 12 21.9996C11.7887 21.9996 11.5794 21.958 11.3842 21.8771C11.189 21.7962 11.0116 21.6777 10.8622 21.5282L2.47106 13.138Z",
    stroke: "#C56A02",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.b39e9a4083e1e54df791a0a01bfdb27e.svg";
export { ForwardRef as ReactComponent };